module.exports = __webpack_public_path__ + "../resources/img/ic_re_error_glass_img.c385fd1c.svg";